import { Box } from '@chakra-ui/react';

const styles = {
  textAlign: 'center',
  overflow: 'hidden',
  '& > .chakra-text': {
    display: 'inline-block',
    pos: 'relative',
  },
  '& > .chakra-text:before, & > .chakra-text:after': {
    content: '""',
    pos: 'absolute',
    top: '50%',
    w: '50vw',
    h: '1px',
    bg: '#E9EBF4',
  },
  '& > .chakra-text:before': {
    right: '100%',
    mr: '8px',
  },
  '& > .chakra-text:after': {
    left: '100%',
    ml: '8px',
  },
};

// Wrap this around a <Text> component to render a horizontal divider with text in the middle.
// Example:
//   <DividerBox>
//     <Text>Some Text</Text>
//   </DividerBox>
function DividerBox(props) {
  return <Box __css={styles} {...props} />;
}

export default DividerBox;
